import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
    Avatar,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Typography,
    makeStyles,
    IconButton,
    Divider,
    Chip
} from '@material-ui/core'
import { AssignmentLateOutlined } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.primary
    },
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        '&:hover': {
            cursor: 'pointer'
        }
    },
    avatar: {}
}))

const ChatCard = ({ className, chat, ...rest }) => {
    const classes = useStyles()

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <CardHeader
                avatar={
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Avatar
                            aria-label="recipe"
                            className={classes.avatar}
                            style={{ marginRight: 4 }}
                        >
                            <img
                                src={chat.users[chat.uids[0]].photoURL}
                                alt={
                                    chat.users[chat.uids[0]].name +
                                    '_' +
                                    chat.users[chat.uids[0]].surname
                                }
                                style={{
                                    width: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                        </Avatar>
                        <span> - </span>
                        <Avatar
                            aria-label="recipe"
                            className={classes.avatar}
                            style={{ marginLeft: 4 }}
                        >
                            <img
                                src={chat.users[chat.uids[1]].photoURL}
                                alt={
                                    chat.users[chat.uids[1]].name +
                                    '_' +
                                    chat.users[chat.uids[1]].surname
                                }
                                style={{
                                    width: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                        </Avatar>
                    </div>
                }
                action={null}
                title={
                    chat.users[chat.uids[0]].name +
                    ' ' +
                    chat.users[chat.uids[0]].surname +
                    ' - ' +
                    chat.users[chat.uids[1]].name +
                    ' ' +
                    chat.users[chat.uids[1]].surname
                }
            />

            <CardContent>
                <Typography style={{ fontSize: 12, color: '#999' }}>
                    {'ID:' + chat.id}
                </Typography>
                <Typography>{chat.lastMessage}</Typography>
            </CardContent>

            <Divider />
            <CardActions disableSpacing>
                <>
                    <IconButton aria-label="show more">
                        <AssignmentLateOutlined />
                    </IconButton>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        {chat.reportCount ? chat.reportCount : 0}
                    </Typography>
                </>
                <div style={{ marginLeft: 'auto' }}>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        Status:{'  '}
                        <Chip
                            color={chat.deleted ? 'default' : 'primary'}
                            label={chat.deleted ? 'deleted' : 'active'}
                            size="small"
                        />
                    </Typography>
                </div>
            </CardActions>
        </Card>
    )
}

ChatCard.propTypes = {
    className: PropTypes.string,
    chat: PropTypes.object.isRequired
}

export default ChatCard
